module.exports = __webpack_public_path__ + "static/media/1Anniversary.57f9f765.png";